import { ControllerFieldState } from "react-hook-form";

export function formControlColorState(field: ControllerFieldState) {
  if (field.error) {
    return "error";
  }
  return "pristine";
}
